import _defineProperty from "/workdir/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/workdir/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workdir/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/workdir/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/workdir/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/workdir/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import BaseLoginRouter from './BaseLoginRouter.js';
import FormController from './controllers/FormController.js';
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

var routes = {
  '': 'defaultAuth',
  '*wildcard': 'defaultAuth'
};

var WidgetRouter = /*#__PURE__*/function (_BaseLoginRouter) {
  _inherits(WidgetRouter, _BaseLoginRouter);

  var _super = _createSuper(WidgetRouter);

  function WidgetRouter(options) {
    _classCallCheck(this, WidgetRouter);

    return _super.call(this, _objectSpread({
      routes: routes
    }, options));
  }

  _createClass(WidgetRouter, [{
    key: "defaultAuth",
    value: function defaultAuth() {
      this.render(FormController);
    }
  }]);

  return WidgetRouter;
}(BaseLoginRouter);

export { WidgetRouter as default };